import request from '@host-panel/request';

type RequestPayload = {
  eventId: string;
  title: string;
  time: number;
  date: number;
  hour: number;
  minute: number;
  timezone: string;
  end: number;
  endDate: number;
  endHour: number;
  endMinute: number;
  reporters: string[];
  lastSeen?: number;
  where?: string;
};

type Response = {
  id: string;
};

export function editLiveBlog({
  eventId,
  title,
  where,
  time,
  date,
  hour,
  minute,
  timezone,
  end,
  endDate,
  endHour,
  endMinute,
  reporters,
  lastSeen
}: RequestPayload): Promise<Response> {
  return request(`/host-panel/live-blog/event/${eventId}`, {
    method: 'PATCH',
    data: {
      title,
      start_time: time,
      date,
      hour,
      timezone,
      minute,
      end_time: end,
      end_date: endDate,
      end_hour: endHour,
      end_minute: endMinute,
      reporters_ids: reporters,
      last_seen: lastSeen,
      where
    }
  });
}
